import { render, staticRenderFns } from "./DatasetAttributeTable.vue?vue&type=template&id=04bf6b1c&"
import script from "./DatasetAttributeTable.vue?vue&type=script&lang=js&"
export * from "./DatasetAttributeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports